import { render, staticRenderFns } from "./company_news.vue?vue&type=template&id=43e45ac4"
import script from "./company_news.vue?vue&type=script&lang=js"
export * from "./company_news.vue?vue&type=script&lang=js"
import style0 from "./company_news.vue?vue&type=style&index=0&id=43e45ac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports